<template>
    <!--
          作者：bbc_team
          时间：2023-06-08
          描述：会员-等级管理
      -->
    <div class="user">
        <!--添加等级-->
        <div class="common-level-rail">
            <el-button v-auth="'/setting/fullreduce/add'" size="small" type="primary" icon="el-icon-plus" @click="addClick">添加活动</el-button>
        </div>

        <!--内容-->
        <div class="goods-content">
            <div class="table-wrap">
                <el-table v-loading="loading" size="small" :data="tableData" border style="width: 100%">
                    <el-table-column prop="active_name" label="活动名称"></el-table-column>
                    <el-table-column prop="full_type" label="满类型">
                        <template slot-scope="scope">
                            <span v-if="scope.row.full_type == 1">满额</span>
                            <span v-if="scope.row.full_type == 2">满件数</span>
                        </template>
                    </el-table-column>
                    <el-table-column prop="full_value" label="满值"></el-table-column>
                    <el-table-column prop="reduce_type" label="减类型">
                        <template slot-scope="scope">
                            <span v-if="scope.row.reduce_type == 1">减金额</span>
                            <span v-if="scope.row.reduce_type == 2">打折</span>
                        </template>
                    </el-table-column>
                    <el-table-column prop="reduce_value" label="减值"></el-table-column>
                    <el-table-column fixed="right" label="操作" width="90">
                        <template slot-scope="scope">
                            <el-button v-auth="'/setting/fullreduce/edit'" type="text" size="small" @click="editClick(scope.row)">编辑</el-button>
                            <el-button v-auth="'/setting/fullreduce/delete'" type="text" size="small" @click="deleteClick(scope.row)">删除</el-button>
                        </template>
                    </el-table-column>
                </el-table>
            </div>

            <!--分页-->
            <div class="pagination">
                <el-pagination
                    background
                    :current-page="curPage"
                    :page-size="pageSize"
                    layout="total, prev, pager, next, jumper"
                    :total="totalDataNumber"
                    @size-change="handleSizeChange"
                    @current-change="handleCurrentChange"
                >
                </el-pagination>
            </div>
        </div>

        <!--添加-->
        <Add v-if="open_add" :open_add="open_add" @closeDialog="closeDialogFunc($event, 'add')"></Add>

        <!--编辑-->
        <Edit v-if="open_edit" :open_edit="open_edit" :form="currentModel" @closeDialog="closeDialogFunc($event, 'edit')"></Edit>
    </div>
</template>

<script>
    import FullreduceApi from "@/api/fullreduce.js";
    import Edit from "./Edit.vue";
    import Add from "./Add.vue";
    import { deepClone } from "@/utils/base.js";
    export default {
        components: {
            /*编辑组件*/
            Edit,
            Add
        },
        data() {
            return {
                /*是否加载完成*/
                loading: true,
                /*列表数据*/
                tableData: [],
                /*一页多少条*/
                pageSize: 20,
                /*一共多少条数据*/
                totalDataNumber: 0,
                /*当前是第几页*/
                curPage: 1,
                /*横向表单数据模型*/
                formInline: {
                    user: "",
                    region: ""
                },
                /*是否打开添加弹窗*/
                open_add: false,
                /*是否打开编辑弹窗*/
                open_edit: false,
                /*当前编辑的对象*/
                currentModel: {}
            };
        },
        created() {
            /*获取列表*/
            this.getTableList();
        },
        methods: {
            /*选择第几页*/
            handleCurrentChange(val) {
                let self = this;
                self.curPage = val;
                self.loading = true;
                self.getTableList();
            },

            /*每页多少条*/
            handleSizeChange(val) {
                this.curPage = 1;
                this.pageSize = val;
                this.getTableList();
            },

            /*获取列表*/
            getTableList() {
                let self = this;
                let Params = {};
                Params.page = self.curPage;
                Params.list_rows = self.pageSize;
                FullreduceApi.getList(Params, true)
                    .then((data) => {
                        self.loading = false;
                        self.tableData = data.data.list.data;
                        self.totalDataNumber = data.data.list.total;
                    })
                    .catch((error) => {});
            },

            /*打开添加*/
            addClick() {
                this.open_add = true;
            },

            /*打开编辑*/
            editClick(item) {
                this.currentModel = deepClone(item);
                this.open_edit = true;
            },

            /*关闭弹窗*/
            closeDialogFunc(e, f) {
                if (f == "add") {
                    this.open_add = e.openDialog;
                    if (e.type == "success") {
                        this.getTableList();
                    }
                }
                if (f == "edit") {
                    this.open_edit = e.openDialog;
                    if (e.type == "success") {
                        this.getTableList();
                    }
                }
            },

            /*删除用户*/
            deleteClick(row) {
                let self = this;
                self.$confirm("此操作将永久删除该记录, 是否继续?", "提示", {
                    confirmButtonText: "确定",
                    cancelButtonText: "取消",
                    type: "warning"
                })
                    .then(() => {
                        self.loading = true;
                        FullreduceApi.del(
                            {
                                fullreduce_id: row.fullreduce_id
                            },
                            true
                        )
                            .then((data) => {
                                self.loading = false;
                                self.$message({
                                    message: data.msg,
                                    type: "success"
                                });
                                self.getTableList();
                            })
                            .catch((error) => {
                                self.loading = false;
                            });
                    })
                    .catch(() => {});
            }
        }
    };
</script>

<style></style>



// WEBPACK FOOTER //
// src/views/setting/fullreduce/index.vue